'use strict';

angular.module('webAgro1App').filter('range', () => {
  return items => _.range(items[0], items[1]);
});
